import { useCallback, useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";
import { CHART_DEFAULT, CHART_PAID_OFF } from "../../../lib/constants";

export const useGetCustomersData = (data: any) => {
  const getValueByCode = useCallback(
    (code: string): number => {
      return data
        ? data.kpiValues.find((item: any) => item.code === code)?.value
        : 0;
    },
    [data]
  );

  const customersData = useMemo(
    () => ({
      values: [
        {
          type: "Individual",
          color: CHART_PAID_OFF,
          value: getValueByCode(KPI_CODES.CUSTOMERS_INDIVIDUAL),
        },
        {
          type: "Company",
          color: CHART_DEFAULT,
          value: getValueByCode(KPI_CODES.CUSTOMERS_COMPANY),
        },
      ],
      colors: [CHART_PAID_OFF, CHART_DEFAULT],
    }),
    [getValueByCode]
  );

  return { customersData };
};
